import { render, staticRenderFns } from "./View.vue?vue&type=template&id=7dd1198b"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7dd1198b')) {
      api.createRecord('7dd1198b', component.options)
    } else {
      api.reload('7dd1198b', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=7dd1198b", function () {
      api.rerender('7dd1198b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/SelectionComponent/View.vue"
export default component.exports